import { RecentAnswer } from "winslow-core";
import "./CollectionStatsQuestionCards.css";
import AnswerCard from "../common/AnswerCard";

export type CollectionStatsQuestionCardsProps = {
  questions: RecentAnswer[]; //questions and answers here are somewhat the same thing so it's used interchangeably - should be cleaned up
};

const CollectionStatsQuestionCards = ({
  questions,
}: CollectionStatsQuestionCardsProps) => {
  return (
    <>
      <div className="cards-section">
        {questions.map((recentAnswer) => (
          <AnswerCard key={recentAnswer.id} recentAnswer={recentAnswer} />
        ))}
      </div>
    </>
  );
};

export default CollectionStatsQuestionCards;
